module.exports = __webpack_public_path__ + "img/sidebar.129bb133.svg";